import React, { FC, useRef } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";

interface StaleFiltersModalProps {
  isOpen: boolean;
}

export const StaleFiltersModal: FC<StaleFiltersModalProps> = ({ isOpen }) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={() => {}}
      closeOnOverlayClick={false}
      closeOnEsc={false}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Report Configuration Changed
          </AlertDialogHeader>

          <AlertDialogBody>
            This report references filters that no longer exist. Please reload
            the page to continue.
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} colorScheme="blue" onClick={handleReload}>
              Reload Page
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
